import { Route } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { LandFormPageService } from '@app/features/land-form/core/services/land-form-page.service';

export const landFormRoute: Route[] = [
  {
    path: '',
    loadComponent: () => import('@app/features/land-form/land-form.component'),
    providers: [LandFormPageService], // ✅ أضف الخدمة هنا
  },
  {
    path: ':mode/:land_id/:category_id',
    loadComponent: () => import('@app/features/land-form/pages/land-form-category-details/land-form-category-details.component')
      .then(m => m.LandFormCategoryDetailsComponent),
    providers: [LandFormPageService], // ✅ أضف الخدمة هنا كمان
  },
];